import { useState, useEffect } from 'react';
import api from '../lib/api';
import type { CurrentElectionCycle } from './useCurrentElectionCycle';

interface UseElectionCyclesReturn {
  cycles: CurrentElectionCycle[];
  loading: boolean;
}

/**
 * All configured campaign-finance cycle windows for a state, most-recent first.
 * Powers the Campaign Finance cycle dropdown; the first entry is the default.
 */
export function useElectionCycles(state = 'CO'): UseElectionCyclesReturn {
  const [cycles, setCycles] = useState<CurrentElectionCycle[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get(`/election-calendars/cycles?state=${encodeURIComponent(state)}`)
      .then(res => {
        if (cancelled) return;
        const rows = res.data?.data || [];
        setCycles(
          rows
            .filter((r: any) => r.cycle_start_date && r.cycle_end_date)
            .map((r: any) => ({
              electionYear: Number(r.election_year),
              name: r.name || null,
              startDate: String(r.cycle_start_date).slice(0, 10),
              endDate: String(r.cycle_end_date).slice(0, 10),
            }))
        );
      })
      .catch(() => { if (!cancelled) setCycles([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [state]);

  return { cycles, loading };
}
